var map = {
	"./10_eriarvoisuuden-vahentaminen.svg": "./src/images/agendaIcons/10_eriarvoisuuden-vahentaminen.svg",
	"./10_eriarvoisuuden-vahentaminen_en_US.svg": "./src/images/agendaIcons/10_eriarvoisuuden-vahentaminen_en_US.svg",
	"./11_kestavat-kaupungit.svg": "./src/images/agendaIcons/11_kestavat-kaupungit.svg",
	"./11_kestavat-kaupungit_en_US.svg": "./src/images/agendaIcons/11_kestavat-kaupungit_en_US.svg",
	"./12_vastuullista-kuluttamista.svg": "./src/images/agendaIcons/12_vastuullista-kuluttamista.svg",
	"./12_vastuullista-kuluttamista_en_US.svg": "./src/images/agendaIcons/12_vastuullista-kuluttamista_en_US.svg",
	"./13_ilmastotekoja.svg": "./src/images/agendaIcons/13_ilmastotekoja.svg",
	"./13_ilmastotekoja_en_US.svg": "./src/images/agendaIcons/13_ilmastotekoja_en_US.svg",
	"./14_vedenalainen-elama.svg": "./src/images/agendaIcons/14_vedenalainen-elama.svg",
	"./14_vedenalainen-elama_en_US.svg": "./src/images/agendaIcons/14_vedenalainen-elama_en_US.svg",
	"./15_maanpaallinen-elama.svg": "./src/images/agendaIcons/15_maanpaallinen-elama.svg",
	"./15_maanpaallinen-elama_en_US.svg": "./src/images/agendaIcons/15_maanpaallinen-elama_en_US.svg",
	"./16_rauha-oikeudenmukaisuus-ja-hyva-hallinto.svg": "./src/images/agendaIcons/16_rauha-oikeudenmukaisuus-ja-hyva-hallinto.svg",
	"./16_rauha-oikeudenmukaisuus-ja-hyva-hallinto_en_US.svg": "./src/images/agendaIcons/16_rauha-oikeudenmukaisuus-ja-hyva-hallinto_en_US.svg",
	"./17_yhteistyo-ja-kumppanuus.svg": "./src/images/agendaIcons/17_yhteistyo-ja-kumppanuus.svg",
	"./17_yhteistyo-ja-kumppanuus_en_US.svg": "./src/images/agendaIcons/17_yhteistyo-ja-kumppanuus_en_US.svg",
	"./1_ei-koyhyytta.svg": "./src/images/agendaIcons/1_ei-koyhyytta.svg",
	"./1_ei-koyhyytta_en_US.svg": "./src/images/agendaIcons/1_ei-koyhyytta_en_US.svg",
	"./2_ei-nalkaa.svg": "./src/images/agendaIcons/2_ei-nalkaa.svg",
	"./2_ei-nalkaa_en_US.svg": "./src/images/agendaIcons/2_ei-nalkaa_en_US.svg",
	"./3_terveytta-ja-hyvinvointia.svg": "./src/images/agendaIcons/3_terveytta-ja-hyvinvointia.svg",
	"./3_terveytta-ja-hyvinvointia_en_US.svg": "./src/images/agendaIcons/3_terveytta-ja-hyvinvointia_en_US.svg",
	"./4_hyva-koulutus.svg": "./src/images/agendaIcons/4_hyva-koulutus.svg",
	"./4_hyva-koulutus_en_US.svg": "./src/images/agendaIcons/4_hyva-koulutus_en_US.svg",
	"./5_sukupuolten-tasa-arvo.svg": "./src/images/agendaIcons/5_sukupuolten-tasa-arvo.svg",
	"./5_sukupuolten-tasa-arvo_en_US.svg": "./src/images/agendaIcons/5_sukupuolten-tasa-arvo_en_US.svg",
	"./6_puhdas-vesi-ja-sanitaatio.svg": "./src/images/agendaIcons/6_puhdas-vesi-ja-sanitaatio.svg",
	"./6_puhdas-vesi-ja-sanitaatio_en_US.svg": "./src/images/agendaIcons/6_puhdas-vesi-ja-sanitaatio_en_US.svg",
	"./7_edullista-ja-puhdasta-energiaa.svg": "./src/images/agendaIcons/7_edullista-ja-puhdasta-energiaa.svg",
	"./7_edullista-ja-puhdasta-energiaa_en_US.svg": "./src/images/agendaIcons/7_edullista-ja-puhdasta-energiaa_en_US.svg",
	"./8_ihmisarvoista-tyota-ja-talouskasvua.svg": "./src/images/agendaIcons/8_ihmisarvoista-tyota-ja-talouskasvua.svg",
	"./8_ihmisarvoista-tyota-ja-talouskasvua_en_US.svg": "./src/images/agendaIcons/8_ihmisarvoista-tyota-ja-talouskasvua_en_US.svg",
	"./9_kestavaa-teollisuutta.svg": "./src/images/agendaIcons/9_kestavaa-teollisuutta.svg",
	"./9_kestavaa-teollisuutta_en_US.svg": "./src/images/agendaIcons/9_kestavaa-teollisuutta_en_US.svg",
	"./economy.png": "./src/images/agendaIcons/economy.png",
	"./education.png": "./src/images/agendaIcons/education.png",
	"./energy.png": "./src/images/agendaIcons/energy.png",
	"./environment.png": "./src/images/agendaIcons/environment.png",
	"./food.png": "./src/images/agendaIcons/food.png",
	"./hiilineutraali-yhteiskunta.png": "./src/images/agendaIcons/hiilineutraali-yhteiskunta.png",
	"./kestavat-elamantavat.png": "./src/images/agendaIcons/kestavat-elamantavat.png",
	"./kestavat-yhdyskunnat.png": "./src/images/agendaIcons/kestavat-yhdyskunnat.png",
	"./luontoa-kunnioittava-paatoksenteko.png": "./src/images/agendaIcons/luontoa-kunnioittava-paatoksenteko.png",
	"./resurssiviisas-talous.png": "./src/images/agendaIcons/resurssiviisas-talous.png",
	"./tyota-kestavasti.png": "./src/images/agendaIcons/tyota-kestavasti.png",
	"./vaikuttavien-kansalaisten-yhteiskunta.png": "./src/images/agendaIcons/vaikuttavien-kansalaisten-yhteiskunta.png",
	"./wellbeing.png": "./src/images/agendaIcons/wellbeing.png",
	"./yhdenvertaisuus.png": "./src/images/agendaIcons/yhdenvertaisuus.png"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/images/agendaIcons recursive ^\\.\\/.*$";


//////////////////
// WEBPACK FOOTER
// ./src/images/agendaIcons ^\.\/.*$
// module id = ./src/images/agendaIcons recursive ^\.\/.*$
// module chunks = 1